import { render, staticRenderFns } from "./EmotionChatSystem.vue?vue&type=template&id=da962ebc&scoped=true"
import script from "./EmotionChatSystem.vue?vue&type=script&lang=js"
export * from "./EmotionChatSystem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da962ebc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('da962ebc')) {
      api.createRecord('da962ebc', component.options)
    } else {
      api.reload('da962ebc', component.options)
    }
    module.hot.accept("./EmotionChatSystem.vue?vue&type=template&id=da962ebc&scoped=true", function () {
      api.rerender('da962ebc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/systemconfig/chat/emotion/EmotionChatSystem.vue"
export default component.exports